export default {
  breadcrumbs: '首页/智慧物联网仪表板',
  menu1: '智慧城市管理',
  menu2: '教材资源管理',
  menu3: '学习活动服务',
  menu4: '班级智慧服务',
}